import { render, staticRenderFns } from "./basket_item.vue?vue&type=template&id=5086dd13&"
import script from "./basket_item.vue?vue&type=script&lang=js&"
export * from "./basket_item.vue?vue&type=script&lang=js&"
import style0 from "./basket_item.vue?vue&type=style&index=0&id=5086dd13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports